const getMetricListItemId = (metric: Metrics.Metric) =>
  `${metric.id}-list-item`;

export default getMetricListItemId;
